import ReactCookies from 'react-cookies';
import { DEFAULT_SEARCH_SUGGESTIONS } from '../brands/default/config';
import { COOKIES } from '../brands/default/constants';
import {
  SUGGESTEDSEARCHURL,
  UNBOXED_SUGGESTED_SEARCH_API,
  SUGGESTED_SEARCH_API,
} from '../brands/default/services';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import httpCommonHeaders from './httpCommonHeaders';

export const getDefaultSuggestions = () => {
  return DEFAULT_SEARCH_SUGGESTIONS;
};

export const getSearchSuggestions = async (searchTerm, location) => {
  const UNBOXED_ENABLED = ReactCookies.load(COOKIES.unboxedSearchTest) === 'b';
  const ssTest = ReactCookies.load(COOKIES.ssTest);

  let url;
  if (ssTest === 'b') {
    url = `${SUGGESTED_SEARCH_API}?q=${searchTerm}`;
  } else if (UNBOXED_ENABLED) {
    url = `${UNBOXED_SUGGESTED_SEARCH_API}?keyword=${searchTerm}&location=${location}`;
  } else {
    url = `${SUGGESTEDSEARCHURL}/${location}?keyword=${searchTerm}`;
  }
  try {
    const response = await axios({
      headers: httpCommonHeaders(),
      method: 'get',
      url,
    });

    if (response && response.data && response.data.length > 0)
      return response.data;

    return null;
  } catch {
    return null;
  }
};
